export default __webpack_public_path__ + "pgnv-assets/b293b89af7f6debcf12589a55fe7d490.png";